<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Prompt:</div>
                <div class="tip-tap-readonly">
                    <span v-html="question.content.question_prompt"></span>
                </div>
            </div>
        </div>

        <div class="text-muted mb-2">Matching Sets:</div>

        <b-list-group>
            <b-list-group-item v-for="(answer, index) in question.content.answer_pairs" :key="index">
                <div v-if="answer.left && answer.right" class="d-flex align-items-center">
                    <div>
                        <div v-if="answer.left.text">{{ answer.left.text }}</div>
                        <div
                            v-if="answer.left.image"
                            :class="{'merlin-asset-border': isMerlinMedia(answer.left.image)}"
                        >
                            <div v-if="isMerlinMedia(answer.left.image)" class="merlin-asset-wrapper">
                                <span class="merlin-asset-warning">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                    Merlin Asset
                                </span>
                            </div>
                            <b-img :src="answer.left.image" height="100" width="auto" />
                        </div>
                    </div>
                    <div class="mx-4">
                        <font-awesome-icon :icon="['fad', 'exchange']" />
                    </div>
                    <div>
                        <div v-if="answer.right.text">{{ answer.right.text }}</div>
                        <div
                            v-if="answer.right.image"
                            :class="{'merlin-asset-border': isMerlinMedia(answer.right.image)}"
                        >
                            <div v-if="isMerlinMedia(answer.right.image)" class="merlin-asset-wrapper">
                                <span class="merlin-asset-warning">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                    Merlin Asset
                                </span>
                            </div>
                            <b-img :src="answer.right.image" height="100" width="auto" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ answer }}
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style scoped>
.tip-tap-readonly {
    padding: 1em;
    border: 1px solid gainsboro;
    border-radius: 5px;
}

>>> p {
    margin-bottom: 0;
}
</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {
        isMerlinMedia(media) {
            return media.toLowerCase().includes('merlinone')
        }
    }
}
</script>
